import React from "react";
import AstronomicLogo from "../AstronomicLogo/AstronomicLogo";
import FormContainerHeader from "../FormContainerHeader/FormContainerHeader";
import FormSkip from "../FormSkip/FormSkip";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import BackButton from "./BackButton/BackButton";
import TextLink from "../TextLink/TextLink";
import "./RegistrationForm.css";

const RegistrationForm = (props) => {
  return (
    <div className={"form-container " + props.containerClassName}>
      <div className="form-container-logo">
        <AstronomicLogo />
      </div>
      <div className="form-content">
        <div
          className="reg-form"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          noValidate={true}
        >
          {/* Form container header */}
          <div className="form-container-header">
            <FormContainerHeader
              hasCounter={props.hasCounter}
              step={props.step}
              headerText={props.headerText}
              hasQuote={props.hasQuote}
              quote={props.quote}
              hasImage={props.hasImage}
              imageSrc={props.imageSrc}
              imageAlt={props.imageAlt}
            />
          </div>
          {/* Form container body */}
          <div
            className={
              props.hasScroller
                ? "form-container-body with-scroller"
                : "form-container-body"
            }
          >
            {props.children}
            {props.hasScroller ? (
              <div
                className="hiding-gradient"
                onClick={(e) => e.stopPropagation()}
              ></div>
            ) : null}
          </div>
          {/* Form container footer */}
          <div className="form-container-footer">
            <div
              className={
                props.showBackButton
                  ? "form-container-footer-row back-show"
                  : "form-container-footer-row"
              }
            >
              {props.showButton ? (
                <PrimaryButton
                  primaryButtonText={props.primaryButtonText}
                  handlePrimaryBtnOnClick={props.handlePrimaryBtnOnClick}
                  activatePrimaryWithEnter={props.activatePrimaryWithEnter}
                />
              ) : null}
              {props.showBackButton ? (
                <BackButton
                  handleBackButtonClick={props.handleBackButtonClick}
                  btnText={props.backButtonText}
                />
              ) : null}
            </div>
            {props.showRegisterLink ? (
              <div className="form-container-footer-register">
                <TextLink text="Sign up" to="/create-account" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="skip-section">
          <FormSkip
            hasSkip={props.hasSkip}
            handleSkipButton={props.handleSkipButton}
          />
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
